import { Size } from '~/types/ThemeTypes'

export const PhoneComponentSizes = {
  Page: {
    padding: {
      [Size.sm]: { int: 60, px: '60px' },
      [Size.md]: { int: 100, px: '100px' },
      [Size.lg]: { int: 140, px: '140px' },
    },
  },
  CallControl: {
    Bar: {
      padding: {
        [Size.sm]: { int: 16, px: '16px' },
        [Size.md]: { int: 16, px: '16px' },
        [Size.lg]: { int: 20, px: '20px' },
        [Size.xl]: { int: 24, px: '24px' },
      },
    },
    Button: {
      boxSize: {
        [Size.sm]: { int: 60, px: '60px' },
        [Size.md]: { int: 60, px: '60px' },
        [Size.lg]: { int: 80, px: '80px' },
      },
    },
  },
  Keypad: {
    ButtonContainer: {
      boxSize: {
        [Size.sm]: { int: 76, px: '76px' },
        [Size.md]: { int: 88, px: '88px' },
        [Size.lg]: { int: 112, px: '112px' },
      },
    },
    Button: {
      boxSize: {
        [Size.sm]: { int: 68, px: '68px' },
        [Size.md]: { int: 80, px: '80px' },
        [Size.lg]: { int: 100, px: '100px' },
      },
    },
  },
}

export const getCallButtonPadding = () => {
  const basePadding =
    (PhoneComponentSizes.Keypad.ButtonContainer.boxSize.sm.int -
      PhoneComponentSizes.Keypad.Button.boxSize.sm.int) /
      2 +
    'px'
  const lgPadding =
    (PhoneComponentSizes.Keypad.ButtonContainer.boxSize.md.int -
      PhoneComponentSizes.Keypad.Button.boxSize.md.int) /
      2 +
    'px'
  const xlPadding =
    (PhoneComponentSizes.Keypad.ButtonContainer.boxSize.lg.int -
      PhoneComponentSizes.Keypad.Button.boxSize.lg.int) /
      2 +
    'px'
  return { base: basePadding, lg: lgPadding, xl: xlPadding }
}
